module.exports = __webpack_public_path__ + "img/noData.3f2b5a97.png";